// extracted by mini-css-extract-plugin
module.exports = {"menuText":"#bfcbd9","menuActiveText":"#409eff","menuBg":"#304156","subMenuActiveText":"#f4f4f5"};